<script setup>
import { useModal } from '@/composables/useModal.js';
import AppButton from '@/components/AppButton.vue';
import SlideOver from '@/components/SlideOver.vue';

const { isOpen } = useModal(false);
defineProps({
    buttonText: {
        type: String,
        required: true,
    },
});
</script>
<script>
export default {
    name: 'AppButtonOptionsPanel',
};
</script>

<template>
    <AppButton element="button" type="button" @click="isOpen = !isOpen">
        {{ buttonText }}
        <SlideOver :show="isOpen" @close="isOpen = false">
            <slot></slot>
        </SlideOver>
    </AppButton>
</template>
